
import { memo } from 'react';
import { cn } from '@/lib/utils';

interface BreakpointMarkerProps {
    nodeId: string;
    isEnabled: boolean;
    isDebugMode: boolean;
    isCurrent: boolean;
    onClick: (nodeId: string) => void;
}

export const BreakpointMarker = memo(function BreakpointMarker({
    nodeId,
    isEnabled,
    isDebugMode,
    isCurrent,
    onClick,
}: BreakpointMarkerProps) {
    if (!isDebugMode) {
        return null;
    }

    return (
        <button
            type="button"
            onClick={(e) => {
                e.stopPropagation();
                onClick(nodeId);
            }}
            className={cn(
                'absolute -top-7 left-2 z-20',
                'h-4 w-4 rounded-full border-2 transition-all duration-150',
                'hover:scale-125 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:ring-offset-1',
                isEnabled
                    ? 'border-red-600 bg-red-500 shadow-sm shadow-red-200'
                    : 'border-slate-400 bg-transparent hover:border-red-400',
                isCurrent && isEnabled && 'animate-pulse ring-2 ring-red-300'
            )}
            title={isEnabled ? 'Remove breakpoint' : 'Add breakpoint'}
            aria-label={isEnabled ? `Remove breakpoint from ${nodeId}` : `Add breakpoint to ${nodeId}`}
        />
    );
});

